import React, { useEffect, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { InputSearch, Loading, Button } from 'Components';
import { Grid, Typography } from '@mui/material';
import Checkbox from 'Components/Checkbox';
import { injectIntl } from 'react-intl';
import { endpoints } from 'Core/defaultValues';
import { findColor } from 'Components/Map/utils';
import { MenuComponent } from 'Components/Menu';
import useExport from 'Components/Table/Export';
import { ExportButton } from 'Components/TableView/Toolbar';
import { OrderData } from 'Core/data/Helpers'
import { Icon } from '@mui/material';
//Views
import GroupCreateEdit from '../geofenceGroupCreateEdit';
import GroupDelete from '../geofenceGroupDelete'; 

import {
    mapGeofencesOpenEditCreateGeofenceGroupModal,
    mapGeofenceGroupOpenDeleteModal
} from 'Redux/actions';

import './style.scss';

const GeofenceSettingsViewGroups = (props) => {

    const { intl } = props;
    const { messages } = intl;

    /*********************************************************
     * Const and useState
    *********************************************************/
    const dispatch = useDispatch()
    const [filter, setFilter] = useState('')
    const [data, setData] = useState([])
    const [selectedRows, setSelectedRows] = useState([]);

    /*********************************************************
     * Use Selector
    *********************************************************/
    const { geofencesGroups, loadingGeofenceGroup } = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux);

    //list of menus
    const landmarkActions = [
        messages['map_landmark_edit'],
        messages['map_landmark_delete']
    ];

    /*********************************************************
     * Use effect to load landmarks groups
    *********************************************************/
    useEffect(() => {
        if (geofencesGroups && geofencesGroups.length > 0) {
            setSelectedRows([]);
            setData(OrderData(geofencesGroups, 'name'));
        } else {
            setData([]);
        }
    }, [geofencesGroups]);

    /*********************************************************
     * Add new checked element into the list
    *********************************************************/
    const selectRow = (row, value) => {
        let newSelectedRows = [];
        if (value) {
            newSelectedRows = [...selectedRows];
            newSelectedRows.push(row);
        } else {
            newSelectedRows = selectedRows.filter(selectedRow => selectedRow.id !== row.id);
        }

        setSelectedRows([...newSelectedRows]);
    }

    /*********************************************************
     * Get the icons from Geofence groups
    *********************************************************/
    const getIconGeofence = useCallback((geofence) => {
        const geofenceGroup = geofencesGroups.find((item) => item.id == geofence.groupId)
        let geofenceColor = geofence.color ? geofence.color : geofenceGroup?.color || '8677D9'
        return geofenceColor
    })

    /********************************************************
     * Define the columns to export data
     ********************************************************/
    const getHeaders = () => {
        return [
            messages["map_landmark_group_manage_export_name"],
            messages["map_landmark_group_manage_export_color"]
        ];
    }

    /********************************************************
     * Get data to generate files PDF or CSV
     ********************************************************/
    const getDataToExport = (rows) => {
        let items = rows ? rows : landmarksItems;
        let data = [];

        //Filter export by selection
        if (selectedRows && selectedRows.length > 0) {
            const onlyIds = selectedRows.map(item => item.id)
            items = items.map((element) => {
                if (onlyIds.includes(element.id))
                    return element
                return null
            })
            items = items.filter(item => item)
        }

        items.forEach((item) => {
            const name = item.name
            const color = item.color ? item.color : "8677D9";
            data.push([name, color]);
        });

        return data;
    }

    /********************************************************
     * Use hook to export PDF
     ********************************************************/
    const exportCSVPdf = useExport(
        getHeaders,
        getDataToExport,
        [],
        data || [],
        null,
        messages['mapGeofenceSettings_geofence_exportgroup'],
        null,
        true
    );

    /*********************************************************
     * Button to export and display this options
    *********************************************************/
    const onExport = (item) => {
        if (item === 'CSV') {
            exportCSVPdf.exportCSV();
        } else if (item === 'PDF') {
            exportCSVPdf.exportPDF();
        }
    }

    /*********************************************************
     * Return selected all items
    *********************************************************/
    const selectAllRows = (checked) => {
        if (checked) {
            setSelectedRows(data);
        } else {
            setSelectedRows([]);
        }
    }

    /*********************************************************
     * Filter landmark groups by key press
    *********************************************************/
    const onSearch = useCallback((value) => {
        setFilter(value);

        if (window.typingTime) {
            clearTimeout(window.typingTime);
        }

        window.typingTime = setTimeout(() => {
            const newFilter = geofencesGroups.filter((item) => item.name.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
            setData(OrderData(newFilter, 'name'));
            window.typingTime = null;
        }, 1000);
    });

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item sm={12}>
                    <InputSearch
                        searchText={filter}
                        onSearch={(param) => onSearch(param)}
                    />
                </Grid>
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                style={{ paddingTop: 10 }}
            >
                <Grid item xs>
                    <Button
                        type="icon"
                        icon="add_box"
                        tooltip={messages['add']}
                        onClick={() => dispatch(mapGeofencesOpenEditCreateGeofenceGroupModal(true))}
                    />

                    <Button
                        type="icon"
                        icon="delete"
                        tooltip={messages['delete']}
                        disabled={!selectedRows.length}
                        onClick={() => dispatch(mapGeofenceGroupOpenDeleteModal(true, selectedRows))}
                    />

                    <ExportButton onExport={onExport} className='landmarkgroup-icon-download' />
                </Grid>

                <Grid item xs>
                    <Checkbox
                        id={'-selectAll'}
                        value={selectedRows.length === data.length}
                        label={messages['map_landmark_select_all']}
                        //size={'sm'}
                        className={'allSelection-checkbox'}
                        onChange={(checked) => {
                            selectAllRows(checked);
                        }}
                    />
                </Grid>
            </Grid>

            <div
                style={{
                    height: "calc(100vh - 450px)",
                    overflow: "auto"
                }}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >
                    {
                        data.map((row, index) => {
                            let selected = selectedRows.find(selectedRow => selectedRow.id === row.id);
                            return (
                                <Grid
                                    key={index}
                                    item
                                    xs
                                    style={{
                                        width: '100%',
                                        margin: 0
                                    }}
                                >
                                    <div style={{ padding: '10px 15px 10px 2px' }}>
                                        <div className={selected ? "landmarks-card landmarks-container-selected" : "landmarks-card landmarks-container"}>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                            >
                                                <Grid item>
                                                    <Checkbox
                                                        id={'checked_' + row?.id}
                                                        value={selected ? true : false}
                                                        label={''}
                                                        //size={'sm'}
                                                        className={'landmark-checkbox'}
                                                        onChange={(checked) => {
                                                            selectRow(row, checked);
                                                        }}
                                                    ></Checkbox>
                                                </Grid>

                                                <Grid item>
                                                    <Icon style={{ paddingRight: 4, width: 24, height: 24, color: `#${getIconGeofence(row)}` }}>
                                                        square
                                                    </Icon>
                                                </Grid>

                                                <Grid 
                                                    item 
                                                    xs 
                                                    zeroMinWidth
                                                    style={{
                                                        paddingRight: 24
                                                    }}
                                                >
                                                    <Typography
                                                        noWrap
                                                        variant="subtitle1"
                                                        className="landmark-title"
                                                    >
                                                        {row?.name}
                                                    </Typography >
                                                </Grid>

                                                <Grid
                                                    item
                                                    style={{ position: 'relative' }}
                                                >
                                                    <MenuComponent
                                                        disabled={loadingGeofenceGroup}
                                                        options={landmarkActions}
                                                        icon={'more_vert'}
                                                        className="landmark-actions icon-menu-vehicle-service showInHover"
                                                        onClick={(type) => {
                                                            if (type === messages['map_landmark_edit']) {
                                                                dispatch(mapGeofencesOpenEditCreateGeofenceGroupModal(true, row.id));
                                                            } else if (type === messages['map_landmark_delete']) {
                                                                dispatch(mapGeofenceGroupOpenDeleteModal(true, [row]));
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </div>

            <GroupCreateEdit/>
            <GroupDelete />
        </div>
    )
}

export default injectIntl(GeofenceSettingsViewGroups)
